import { Row } from 'antd';
// Import dei loghi dagli assets
import HANDSON_LOGO from '../../../assets/sponsors/handson_logo_whitee.jpeg'; 
import VISIT_MALTA_LOGO from '../../../assets/sponsors/VisitMalta.png';
import GMOLTON_LOGO from '../../../assets/sponsors/gmolton_logo_white.png';
import MUSCATS_LOGO from '../../../assets/sponsors/Muscats_Motors_logo.png';
import FRANKS_LOGO from '../../../assets/sponsors/Franks.png'; // Nuovo Import
import TWISTEES_LOGO from '../../../assets/sponsors/twistees.png';
import './Sponsors.css';

const Sponsors = () => {
    return (
        <Row className="sponsors-section">
            <div className='sub-title'>Main Sponsors</div>
            <div className="sponsors">
                {/* 1. Visit Malta (Il più importante - Classe featured) */}
                <div className="single-logo featured">
                    <img src={VISIT_MALTA_LOGO} alt="visit malta" />
                </div>
                
                {/* 2. HandsOn */}
                <div className="single-logo">
                    <img src={HANDSON_LOGO} alt="hands on" />
                </div>

                {/* 3. G Molton */}
                <div className="single-logo">
                    <img src={GMOLTON_LOGO} alt="gmolton" />
                </div>

                {/* 4. Muscats */}
                <div className="single-logo">
                    <img src={MUSCATS_LOGO} alt="muscats" />
                </div>

                {/* 5. Franks (Inserito prima di Twistees come richiesto) */}
                <div className="single-logo logo-franks">
                    <img src={FRANKS_LOGO} alt="franks" />
                </div>

                {/* 6. Twistees */}
                <div className="single-logo">
                    <img src={TWISTEES_LOGO} alt="twistees" />
                </div>
            </div>
        </Row>
    );
};

export default Sponsors;